import { useEffect, useState } from "react";
import {
    collection,
    query,
    where,
    orderBy,
    getDocs, onSnapshot
} from "firebase/firestore";
import { dbstatus } from "../firebase.js";
import { useNavigate } from "react-router-dom";
import { GoDownload, GoHeart } from "react-icons/go";
import Cookies from "js-cookie";
import { Create_status_message_qry } from "./create_status_message.js";
import "./status.css";
import CopyUID from "../components_root/copyuid.jsx";
import { Toast } from "../components_root/ToastContext.jsx";
import ShareButton from "../components_root/ShareButton.jsx";
import { DetectLanguage } from "./detectLanguage.js";
import { MdDeleteForever } from "react-icons/md";
import { Delete_status_message_qry } from "./delete_status_message.js";
import { Randomcode } from "../components_root/rendom_code";
import { IoIosColorPalette } from "react-icons/io";
export default function Post_status() {
    const navigate = useNavigate();
    const { Toastshow } = Toast();
    const [islogin, setislogin] = useState(true);
    const [posting, setposting] = useState(false);
    const [statusdata, setstatusdata] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusmessage, setstatusmessage] = useState("");
    const [statusmood, setstatusmood] = useState("happy");
    const [statusmoodEmoji, setstatusmoodEmoji] = useState("😊");
    const [statuscolor, setStatuscolor] = useState("#ff6b6b");
    const [guid, setguid] = useState("");
    const handleBackHome = () => {
        navigate("/");
    };

    useEffect(() => {
        const guid = Cookies.get("guid");
        if (guid) {
            setguid(guid);
            setislogin(true);
        } else {
            setislogin(false);
        }
    }, []);

    const API_KEY = "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";

    async function getMessage() {
        try {
            const res = await fetch("https://api.openai.com/v1/chat/completions", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${API_KEY}`,
                },
                body: JSON.stringify({
                    model: "gpt-4.1-mini",
                    messages: [{ role: "user", content: "Give me a love status under 140 characters" }],
                }),
            });

            const data = await res.json();

            const message = data?.choices?.[0]?.message?.content || "";
            setstatusdata(message);
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        getMessage();
    }, []);

    const create_status_message = async () => {

        if (!statusmessage || !statusmessage.trim()) {
            return;
        }
        if (statusmessage.length < 60 || !statusmessage.trim()) {
            Toastshow("Min length 100")
            return;
        }
        if (statusmessage.length > 170 || !statusmessage.trim()) {
            Toastshow("Max length 170")
            return;
        }
        setposting(true);
        const rse = await isContentDuplicate(statusmessage);
        if (rse === true) {
            setTimeout(() => {
                Toastshow("Content Duplicate");
                setposting(false);
            }, 3000); // 5 seconds
            return;
        }
        try {
            const contentid = Randomcode(10);
            const lang = DetectLanguage(statusmessage);
            const res = await Create_status_message_qry({
                contentid,
                message: statusmessage,
                language: lang.name,
                langcode: lang.code,
                length: statusmessage.length,
                statusmood,
                statusmoodEmoji,
                statuscolor,
                status: true
            });
            if (res?.success) {
                setStatuscolor(getStatusColor(statusmood));
                setstatusmessage("");
                //Toastshow("Status message saved");
            } else {
                Toastshow(res.error);
            }

            setTimeout(() => {
                setposting(false);
            }, 3000); // 5 seconds
        } catch (err) {
            setposting(false);
            Toastshow("Error saving status message:", err);
        }

    };
    const statusColors = [
        "#ff6b6b",  // red
        "#4dabf7",  // blue
        "#51cf66",  // green
        "#be9e0c",  // yellow
        "#845ef7",  // purple
        "#ff922b",  // orange
        "#20c997",  // teal
        "#f06595",  // pink
        "#748ffc",  // indigo
        "#94d82d",  // lime
        "#ffa94d",  // light orange
        "#66d9e8",  // cyan
        "#e599f7",  // violet 
        "#ffd43b"   // gold
    ];
    const categoryColors = {
        love: ["#8b1e3f", "#a61e4d", "#7a1c3a", "#5c132d", "#6b1835"],

        happy: ["#b08900", "#995c00", "#7a4e00", "#5c3d00"],

        sad: ["#1c3d5a", "#1e4d6b", "#163a52", "#102c40"],

        angry: ["#7a1c1c", "#5c1313", "#3d0d0d", "#8b2323"],

        funny: ["#7a3e00", "#5c2e00", "#4a2500", "#8b4500"],

        motivated: [
            "#0b5d1e",
            "#0f7a29",
            "#145c32",
            "#0a3d1a",
            "#1b7f3a"
        ],

        thinking: ["#3d2c8d", "#4c3aa3", "#2e2470", "#241a5a"],

        shayari: [
            "#7a1c1c",  // dark red
            "#1c3d5a",  // dark blue
            "#1f6f3f",  // dark green
            "#7a6600",  // dark yellow
            "#3d2c8d",  // dark purple
            "#7a3e00",  // dark orange
            "#0f766e",  // dark teal
            "#8b1e4d",  // dark pink
            "#2b3f8f",  // dark indigo
            "#4d7c0f",  // dark lime
            "#995c00",  // burnt orange
            "#0e7490",  // deep cyan
            "#6b21a8",  // dark violet
            "#b08900"   // dark gold
        ],
        business: [
            "#0b3c5d", // deep corporate blue
            "#0f4c75",
            "#1b262c",
            "#0a2239",
            "#0f766e",  // dark teal
            "#8b1e4d",  // dark pink
            "#2b3f8f",  // dark indigo
            "#4d7c0f",  // dark lime
            "#995c00",  // burnt orange
            "#0e7490",  // deep cyan
            "#6b21a8",  // dark violet
            "#b08900"   // dark gold
        ],

        golden_Rule: [
            "#b08900", // dark gold
            "#995c00",
            "#7a4e00",
            "#5c3d00"
        ],

        money: [
            "#7a1c1c",  // dark red
            "#1c3d5a",  // dark blue
            "#1f6f3f",  // dark green
            "#7a6600",  // dark yellow
            "#3d2c8d",  // dark purple
            "#7a3e00",  // dark orange
            "#0f766e",  // dark teal
            "#8b1e4d",  // dark pink
            "#2b3f8f",  // dark indigo
            "#4d7c0f",  // dark lime
            "#995c00",  // burnt orange
            "#0e7490",  // deep cyan
            "#6b21a8",  // dark violet
            "#b08900"   // dark gold
        ]
    };
    function getStatusColor(category) {
        const colors = categoryColors[category];

        if (!colors) return "#748ffc"; // default color

        return colors[Math.floor(Math.random() * colors.length)];
    }
    const get_status_message = () => {

        const q = query(
            collection(dbstatus, "statusmessage"),
            where("statusmood", "==", statusmood),
            where("guid", "==", guid),
            orderBy("date_time", "desc"),
        );

        const unsubscribe = onSnapshot(
            q,
            async (snapshot) => {

                const data = await Promise.all(
                    snapshot.docs.map(async (doc) => {

                        const statusData = doc.data();

                        const checkQuery = query(
                            collection(dbstatus, "accounts"),
                            where("guid", "==", statusData.guid)
                        );

                        const accountSnap = await getDocs(checkQuery);

                        let accountInfo = null;

                        accountSnap.forEach((acc) => {
                            accountInfo = acc.data();
                        });

                        return {
                            id: doc.id,
                            ...statusData,
                            accountInfo
                        };
                    })
                );

                setstatusdata(data);
                setLoading(false);
            },
            (error) => {
                console.error("Error fetching status messages:", error);
            }
        );

        return unsubscribe;
    };

    useEffect(() => {
        const unsubscribe = get_status_message();

        return () => {
            if (unsubscribe) unsubscribe();
        };
    }, [statusmood, guid]);

    const moodEmoji = {
        happy: "😊",
        shayari: "🪶",
        sad: "😢",
        love: "❤️",
        angry: "😡",
        funny: "😂",
        motivated: "🔥",
        thinking: "🤔",
        business: "💼",
        golden_Rule: "🌟",
        money: "💰"
    };
    function timeAgo(date) {

        const seconds = Math.floor((Date.now() - new Date(date)) / 1000);

        if (seconds < 60) return seconds + " sec ago";

        const minutes = Math.floor(seconds / 60);
        if (minutes < 60) return minutes + " min ago";

        const hours = Math.floor(minutes / 60);
        if (hours < 24) return hours + " h ago";

        const days = Math.floor(hours / 24);
        if (days < 30) return days + " d ago";

        const months = Math.floor(days / 30);
        if (months < 12) return months + " m ago";

        const years = Math.floor(months / 12);
        return years + " y ago";
    }
    const isContentDuplicate = async (newContent, threshold = 0.9) => {

        const q = query(
            collection(dbstatus, "statusmessage"),
            where("statusmood", "==", statusmood)
        );

        const snapshot = await getDocs(q);

        for (let doc of snapshot.docs) {

            const existing = doc.data()?.message;

            if (!existing) continue;

            const similarity = calculateSimilarity(newContent, existing);

            if (similarity >= threshold) {
                return true;
            }

        }

        return false;
    };
    function calculateSimilarity(a, b) {

        a = normalizeText(a);
        b = normalizeText(b);

        const wordsA = a.split(" ");
        const wordsB = b.split(" ");

        if (!wordsA.length || !wordsB.length) return 0;

        const setA = new Set(wordsA);
        const setB = new Set(wordsB);

        let common = 0;

        setA.forEach(word => {
            if (setB.has(word)) {
                common++;
            }
        });

        const similarity = common / Math.max(setA.size, setB.size);

        return similarity;
    }
    function normalizeText(text) {
        if (!text) return "";

        return text
            .toLowerCase()
            .replace(/[^\p{L}\p{N}\s]/gu, "")
            .replace(/\s+/g, " ")
            .trim();
    }
    const handleChange = (e) => {
        const textarea = e.target;
        textarea.style.height = "auto";          // reset height
        textarea.style.height = textarea.scrollHeight + "px"; // set new height
        setstatusmessage(textarea.value);
    };

    return (
        <>
            <div className="app_header_height"></div>

            <div className="container_roots">
                <div className="container_size">
                    <div className="post-container">
                        <div className="post_div">
                            <div className="mood-list m-2">
                                {Object.entries(moodEmoji).map(([mood, emoji]) => (
                                    <div
                                        key={mood}
                                        className={`mood-item ${statusmood === mood ? "active" : ""}`}
                                        onClick={() => { setstatusmood(mood); setstatusmoodEmoji(emoji); setStatuscolor(getStatusColor(mood)) }}
                                    >
                                        <span>{emoji}</span>
                                        <span className="fcap">{mood}</span>
                                    </div>
                                ))}
                            </div>
                            <div style={{ maxWidth: 600 }} >
                                <textarea
                                    className="border-none p-22 text-h1 bold line-height-25 text-white"

                                    maxLength={500}
                                    value={statusmessage}
                                    style={{ backgroundColor: statuscolor, minHeight: "80px", resize: "none", overflow: "hidden" }}
                                    onChange={(e) => {
                                        handleChange(e);

                                    }}
                                />

                                {/* <div className="color-list">
                                    {statusColors.map((color, index) => (
                                        <div
                                            key={index}
                                            className="color-item"
                                            style={{ background: color }}
                                            onClick={() => setStatuscolor(color)}
                                        ></div>
                                    ))}
                                </div> */}

                                <br />
                                <table>
                                    <tr>
                                        <td width={40}><div onClick={() => setStatuscolor(getStatusColor(statusmood))}><IoIosColorPalette className="icon cursor" style={{ color: statuscolor }} /></div></td>
                                        <td className="text-h1 text-off">Length {statusmessage.length}</td>
                                        <td width={80}>
                                            {
                                                posting === true ? (
                                                    <div className="button-ui p-22 rounded m-top text-h1">
                                                        Posting...
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="button-ui p-22 rounded m-top text-h1 cursor"
                                                        onClick={create_status_message}
                                                    >
                                                        Post
                                                    </div>
                                                )
                                            }
                                        </td>
                                    </tr>
                                </table>

                            </div>
                        </div>
                        <div className="post_updates"></div>
                    </div>
                    <br />
                    {/* data list */}
                    <div className="ui-grid">

                        {loading ? (
                            <p>Loading...</p>
                        ) : statusdata.length > 0 ? (

                            statusdata.map((row) => (

                                <div key={row.id} className="ui-items items-back-fill rounded">

                                    <table>
                                        <tbody>
                                            <tr>
                                                <td width={30}>
                                                    <img
                                                        className="icon-photo-30"
                                                        src={row.accountInfo?.photoURL || "/default-user.png"}
                                                        alt="user"
                                                    />
                                                </td>

                                                <td>
                                                    <div className="text-h2 bold">{row.accountInfo?.name}</div>
                                                    <div className="text-h4 text-off">
                                                        {row.date_time ? new Date(row.date_time).toLocaleString() : ""}
                                                    </div>
                                                </td>

                                                <td width={85} className="text-r text-h2">
                                                    {row.date_time ? timeAgo(row.date_time) : ""}
                                                </td>

                                                <td width={30}>
                                                    <ShareButton url={row.contentid} />
                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>

                                    <div
                                        className="p-44 text-white "
                                        style={{ minHeight: "110px", backgroundColor: row.statuscolor }}
                                    >

                                        <div
                                            className="text-h1 bold line-height-25"
                                            dangerouslySetInnerHTML={{ __html: row.message }}
                                        />

                                        <table className="table-fixed">
                                            <tbody>
                                                <tr>
                                                    <td  >
                                                        <div className="text-h2 fcap">
                                                            {row.statusmoodEmoji} {row.statusmood}
                                                        </div>
                                                    </td>

                                                    <td className="text-h2 fcap">
                                                        #{row.accountInfo?.username}
                                                    </td>

                                                    <td className="bold text-h1">
                                                        Aooz.in
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>

                                    <div className="p-0 ">
                                        <table className="table-fixed">
                                            <tbody>
                                                <tr>
                                                    <td  >
                                                        <div className="text-h4 text-l fcap">
                                                            {row.contentid}
                                                        </div>
                                                    </td>
                                                    <td  >
                                                        <div className="text-h3 fcap">
                                                            Char  {row.length || 0}
                                                        </div>
                                                    </td>
                                                    <td className="text-h3 fcap">
                                                        {row.language}
                                                    </td>

                                                    <td className="bold text-h3">
                                                        {row.country}
                                                    </td>

                                                    {row.read > 2 ? "" : <td width={30} className="bold text-h3"> <MdDeleteForever onClick={() => Delete_status_message_qry(row.contentid)} className="icon red cursor" /> </td>}


                                                </tr>
                                            </tbody>
                                        </table>
                                        <table className="table-fixed">
                                            <tbody>
                                                <tr>

                                                    <td>
                                                        <div className="text-h3">
                                                            <b>{row.read || 0}</b> Read
                                                        </div>
                                                    </td>

                                                    <td>
                                                        <div className="text-h3">
                                                            <b>{row.read || 0}</b> Comt
                                                        </div>
                                                    </td>

                                                    <td>
                                                        {/* <IoColorPaletteOutline className="icon" /> */}
                                                    </td>

                                                    <td>
                                                        <CopyUID id={row.message} />
                                                    </td>

                                                    <td>
                                                        <GoDownload className="icon cursor" />
                                                    </td>

                                                    <td>
                                                        <GoHeart className="icon cursor" />
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>

                            ))

                        ) : (
                            <p>No status found</p>
                        )}

                    </div>
                </div>
            </div>
        </>
    );
}